module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal layout__box"
  }, [_c('table', {
    staticClass: "basic-table personal__basic-table"
  }, _vm._l((_vm.personal), function(worker) {
    return _c('tr', {
      staticClass: "basic-table__row hr"
    }, [_c('td', {
      staticClass: "basic-table__cell personal__img-cell"
    }, [_c('div', {
      staticClass: "basic-table__avatar-wrap personal__img-wrap"
    }, [_c('user-avatar', {
      attrs: {
        "data": worker.user,
        "set-class": 'basic-table__avatar'
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell personal__name"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(worker.user.last_name) + " " + _vm._s(worker.user.first_name) + " " + _vm._s(worker.user.middle_name) + "\n\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell personal__position"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(worker.position) + "\n\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell personal__link"
    }, [_c('router-link', {
      staticClass: "basic-table__link",
      attrs: {
        "to": {
          name: 'Profile',
          params: {
            profile: worker._id
          }
        }
      }
    }, [_vm._v("Детали\n\t\t\t\t")])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3013cd13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Clinic/Tabs/Personal.vue
// module id = 598
// module chunks = 0